import { render, staticRenderFns } from "./TaskTooltip.vue?vue&type=template&id=b033171a"
import script from "./TaskTooltip.vue?vue&type=script&lang=js"
export * from "./TaskTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports